import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Users } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class UserModule extends VuexModule {
  @Action
  [Users.saveUser](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/user/save", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Users.userDownload](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/user/userDownload", values, { responseType: "blob" })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Users.blockUser](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/user/blockUser", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Users.deleteUser](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/user/delete", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Users.changePassword](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/user/changePassword", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Users.changePasswordSelf](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/user/changePasswordSelf", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Users.findUserByName](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/user/findByName", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Users.findUserPermissions](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.get(`/user`,`findPermissions?name=${values.name}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Users.findAllUser](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/user/findAll", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Users.findPageUser](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/user/findPage", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Users.getUserInfo]() {
    return new Promise<void>((resolve, reject) => {
      ApiService.get("/user/userinfo")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }


  /* sys-admin-end */

  /* company-admin-start */

  /* user-start */
}
